import { ReportStatisticsResponse } from '../Interfaces/Reports.interfaces';
import { get } from './api.service';

const base_url = 'bookings/v1/reports';

export const getAllWorkers = (params: {
    page?: number,
    per_page?: number,
    search?: string,
    start_date?: string,
    end_date?: string,
    type?: string,
    status?: string,
    order?: string,
    byMonth?: string,
    perDay?: string,
    worker_id?: number | (number | string)[]
} = {}) => {
    const queryString = Object.keys(params)
        .filter(key => params[key as keyof typeof params])
        .map(key => {
            return `${key}=${params[key as keyof typeof params]}`;
        }).join('&');

    let url = base_url + '/workers';

    return get(queryString ? url + `?${queryString}` : url);
}

export const getWorkerById = (id: number, params: string = '') => {
    return get(`${base_url}/workers/${id}${params}`);
}



/** Get all the comparative statistics related to booking services */
export const getStatistics = (params: {
    start_date?: string,
    end_date?: string,
    operator_id?: number|string,
} = {}): Promise<ReportStatisticsResponse> => {
    const queryString = Object.keys(params)
        .filter(key => params[key as keyof typeof params])
        .map(key => `${key}=${params[key as keyof typeof params]}`)
        .join('&');

    let url = `${base_url}/statistics`;
    return get<ReportStatisticsResponse>(queryString ? url + `?${queryString}` : url);
};
